<template>
    <div>
        <div v-if="totalReferredAmount && totalReferredAmount.length > 0">
            <div
                v-for="({ amount, currency_code }, key) in totalReferredAmount"
                :key="key"
            >
                <p class="text--primary text-h4 mb-0">
                    {{ currency_code || 'NGN' }}
                    <span class="text-h3">
                        {{ amount || 0.00 }}
                    </span>
                </p>
            </div>
        </div>
        <div v-else>
            <p class="text--primary text-h4 mb-0">
                NGN
                <span class="text-h3">
                    0.00
                </span>
            </p>
        </div>
        <p class="grey--text">
            Total Referred Amount
        </p>
    </div>
</template>

<script>
export default {
    props: {
        totalReferredAmount: {
            type: Array,
            default: () => ([]),
        },
    },
};
</script>
